import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslate } from '../../mixins/translate/translate';
import { IValidationComponentState, useOldValidation, ValidationHelpText, ValidationRenderMessage } from '../../mixins/validation/validation';
import { fetchGet, fetchPost } from '../../store/fetch';
import {
    EditPanelCell,
    EditPanelInput,
    EditPanelRow,
    EditPanelSection,
    EditPanelSwitch,
    EditPanelTextArea,
    PanelHeader,
    PanelTopHeading,
} from '../elements';

interface ISupportState extends IValidationComponentState {
    message?: string;
    submitted: boolean;
    failed: boolean;
    userName?: string;
    emailAddress?: string;
    mobileNumber?: string;
    officeNumber?: string;
    companyName?: string;
    remark?: string;
    callMe: boolean;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function SupportHook(props: { location: { query: { errorcode?: string } } }) {
    const translate = useTranslate();

    const { validate, formState, handleChange, setFormState, handleValidation, getValidationMessages } = useOldValidation<ISupportState>({
        initialState: {
            submitting: false,
            failed: false,
            saved: false,
            submitted: false,
            callMe: false,
            errors: [],
        },
        getValidatorTypes() {
            return {
                // companyName: Joi.string().required().label(translate('common.name')),
            };
        },
        getValidatorData(innerFormState: ISupportState) {
            return {
                userName: innerFormState.userName,
                companyName: innerFormState.companyName,
                mobileNumber: innerFormState.mobileNumber,
                officeNumber: innerFormState.officeNumber,
                emailAddress: innerFormState.emailAddress,
                callMe: innerFormState.callMe,
                remark: innerFormState.remark,
                errorCode: props.location.query.errorcode,
            };
        },
    });

    React.useEffect(() => {
        const fetchData = async () => {
            const url = '/api/personaldata';
            const result = await fetchGet(url);
            setFormState({ ...result.json, ...{ userName: `${result.json.firstName} ${result.json.lastName}`, companyName: result.json.name } });
        };

        void fetchData();
    }, [setFormState]);

    function saveClicked(e: any) {
        e.preventDefault();
        validate(async (error: any, data: any) => {
            if (!error) {
                const url = '/api/support';
                await fetchPost(url, {}, data);
                setFormState({ ...formState, ...{ submitted: true, failed: false } });
            }
        });
    }

    return (
        <div>
            <header id="topbar" className="ph10">
                <div className="topbar-left">
                    <ol className="breadcrumb">
                        <li>
                            <span className="fa fa-comments-o pr10 fs18"></span>
                        </li>
                        <li className="crumb-active">
                            <Link to="/support">{translate('support.support')}</Link>
                        </li>
                    </ol>
                </div>
            </header>

            <section id="content" className="">
                <div className="tray tray-center">
                    <div className="admin-form theme-primary mw700 mt40 center-block" style={{ paddingBottom: '175px' }}>
                        <ValidationRenderMessage {...formState} />
                        <div className="panel heading-border">
                            <form method="post" action="/" id="admin-form">
                                <PanelTopHeading>{translate('support.supportHeader')}</PanelTopHeading>
                                <div className="panel-body bg-light">
                                    <PanelHeader text={translate('support.myData')} />
                                    {/* Name and companyname*/}
                                    <EditPanelRow>
                                        <EditPanelCell rowCount={6}>
                                            <EditPanelInput
                                                name="userName"
                                                placeholder={translate('user.firstName')}
                                                value={formState.userName}
                                                icon="fa fa-user"
                                                handleChange={handleChange}
                                            />
                                        </EditPanelCell>
                                        <EditPanelCell rowCount={6}>
                                            <EditPanelInput
                                                name="companyName"
                                                placeholder={translate('company.companyName')}
                                                value={formState.companyName}
                                                icon="fa fa-building"
                                                handleChange={handleChange}
                                                handleBlur={() => handleValidation()}
                                            />
                                            <ValidationHelpText message={getValidationMessages('companyName')} />
                                        </EditPanelCell>
                                    </EditPanelRow>

                                    <EditPanelRow>
                                        <EditPanelCell rowCount={6}>
                                            <EditPanelInput
                                                name="emailAddress"
                                                placeholder={translate('user.emailAddress')}
                                                value={formState.emailAddress}
                                                icon="fa fa-envelope"
                                                handleChange={handleChange}
                                            />
                                        </EditPanelCell>
                                    </EditPanelRow>

                                    {/* Call me back */}
                                    <EditPanelSection>
                                        <EditPanelSwitch
                                            name="callMe"
                                            placeholder={translate('support.callMeBack')}
                                            value={formState.callMe}
                                            handleChange={handleChange}
                                        />
                                    </EditPanelSection>

                                    {/* Phone numbers */}
                                    {formState.callMe && (
                                        <EditPanelRow>
                                            <EditPanelCell rowCount={6}>
                                                <EditPanelInput
                                                    name="mobileNumber"
                                                    placeholder={translate('user.mobileNumber')}
                                                    value={formState.mobileNumber}
                                                    icon="fa fa-mobile-phone"
                                                    handleChange={handleChange}
                                                />
                                            </EditPanelCell>
                                            <EditPanelCell rowCount={6}>
                                                <EditPanelInput
                                                    name="officeNumber"
                                                    placeholder={translate('user.officeNumber')}
                                                    value={formState.officeNumber}
                                                    icon="fa fa-phone"
                                                    handleChange={handleChange}
                                                />
                                            </EditPanelCell>
                                        </EditPanelRow>
                                    )}

                                    {/* Support question */}
                                    <div className="section-divider mt40 mb40">
                                        <span>{translate('support.question')}</span>
                                    </div>

                                    <EditPanelSection>
                                        <EditPanelTextArea
                                            name="remark"
                                            placeholder={translate('support.question')}
                                            value={formState.remark}
                                            icon="fa fa-question"
                                            handleChange={handleChange}
                                        />
                                    </EditPanelSection>
                                </div>
                                <div className="panel-footer text-right">
                                    <button className="button btn-primary" onClick={(e: any) => saveClicked(e)}>
                                        {' '}
                                        {translate('support.submit')}{' '}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
